import constants from "../constants";
import TestDueHooks from "./TestDueHooks";
import { getDataFromStorage } from "../util";
import useAxiosPrivate from "./useAxiosPrivate";
import ContentPageHooks from "./ContentPageHooks";
import AlertContext from "../context/AlertContext";
import { useContext, useRef, useState } from "react";
import AssignmentPageHooks from "./AssignmentPageHooks";
import useCommonFunctionHooks from "./useCommonFunctionHooks";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function LeftNavBarHooks() {
  const Alert = useContext(AlertContext);

  const { lpid, mid } = useParams();
  const isPreview = new URLSearchParams(window.location.search).get("mode") === "preview";

  const axios = useAxiosPrivate();
  const { currentDueLabel } = TestDueHooks();
  const { handleContent } = ContentPageHooks();
  const { handleAssignment } = AssignmentPageHooks();

  const {
    handleRegistration,
    getCatchBlockDetails,
    getHeaderDetailsForAxios
  } = useCommonFunctionHooks();

  const activeTestRef = useRef(null);

  const [collapsed, setCollapsed] = useState(false);

  const openModule = (module) => {
    Alert.setModuleActive(true);
    Alert.setModule({ id: module.modid, name: module.modname });
  };

  const openTest = (test) => {
    if (test === undefined) {
      Alert.navigate("/main/cc");
      return;
    } else {
      Alert.setIsTakeTest(false);
      localStorage.removeItem("hideBatch");
      Alert.register.current = Alert.registered;
      Alert.setLpId(parseInt(sessionStorage.getItem("lpId")));

      if (
        document.fullscreenElement &&
        (test.testtype !== constants.libTypeIds.MCQ ||
          test.testtype !== constants.libTypeIds.DESCRIPTIVE ||
          test.testtype !== constants.libTypeIds.CODING_SNIPPET) &&
        test.status !== constants.PROGRESS_STATUS.UNLOCKED &&
        test.status !== constants.PROGRESS_STATUS.REATTEMPT &&
        test.status !== constants.PROGRESS_STATUS.QN_CONTINUE
      ) {
        document.exitFullscreen();
      }

      Alert.setCurrentStep(0);
      Alert.setTestData(test);
      Alert.setContentData({});
      Alert.setShowMain(false);
      Alert.setTestActive(true);
      Alert.setStatus(test.status);
      Alert.setShowInstruction(false);
      Alert.setTestId(test.testid !== null ? test.testid : test.libid);

      if (test.libtype === constants.libTypeIds.CONTENT) {
        handleContent(
          test.libtype,
          test.lpconfigid,
          test.libid,
          test.status,
          test.duedate
        );
      } else if (test.libtype === constants.libTypeIds.ASSIGNMENT) {
        if (document.fullscreenElement) {
          document.exitFullscreen();
          Alert.setShowInstruction(false);
        }

        handleAssignment(
          test.libtype,
          test.lpconfigid,
          test.libid,
          test.status,
          test.duedate
        );
      } else if (test.testtype === constants.libTypeIds.CODING_CHALLENGE) {
        if (document.fullscreenElement) {
          document.exitFullscreen();
          Alert.setShowInstruction(false);
        }
      } else {
        if (
          (localStorage.getItem("mockLp") ||
            currentDueLabel(test.duedate) !== "Past Due" ||
            parseInt(localStorage.getItem("batchType")) ===
              constants.BATCH_TYPE.SELF) &&
          test.status !== constants.PROGRESS_STATUS.EVALUATED &&
          test.status !== constants.PROGRESS_STATUS.TO_BE_EVALUATED &&
          test.status !== constants.PROGRESS_STATUS.PARTIAL_EVALUATED &&
          !isPreview
        ) {
          document.documentElement.requestFullscreen().catch((err) => err);
          Alert.setCurrentStep(0);
          Alert.setShowInstruction(true);
        }
      }
      Alert.setShowMain(true);
    }
  };

  const calculatePercentage = (completedItems, totalItems) => {
    if (totalItems !== 0) {
      let percentage = Math.round((completedItems / totalItems) * 100);

      return percentage;
    } else {
      return 0;
    }
  };

  const getTestForOrderMandate = (moduleData) => {
    let testOpened = false;

    moduleData.forEach((module) => {
      if (testOpened) return;

      module.data.some((test) => {
        if (
          test?.status === constants.PROGRESS_STATUS.UNLOCKED ||
          test?.status === constants.PROGRESS_STATUS.REATTEMPT ||
          test?.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
          test?.status === constants.PROGRESS_STATUS.QN_CONTINUE ||
          test?.status === constants.PROGRESS_STATUS.IN_PROGRESS
        ) {
          Alert.setModuleActive(true);
          Alert.setModule({
            id: module.modid,
            name: module.modname,
          });

          openTest(test);
          testOpened = true;

          return true;
        }

        if (module.modid === Alert.module.id && test.testid === Alert.testId) {
          openTest(test);
          testOpened = true;

          return true;
        }

        return false;
      });
    });

    if (!testOpened) {
      Alert.setModuleActive(true);
      Alert.setModule({
        id: moduleData[0].modid,
        name: moduleData[0].modname,
      });
      openTest(moduleData[0].data[0]);
      testOpened = true;

      return true;
    }
  };

  const getTest = (lpData) => {
    for (let i = 0; i < lpData.modules.length; i++) {
      Alert.setModuleActive(true);
      Alert.setModule({
        id: lpData.modules[i].modid,
        name: lpData.modules[i].modname,
      });

      for (let j = 0; j < lpData.modules[i]?.data?.length; j++) {
        // if (
        //   !isPreview &&
        //   (lpData.modules[i].data[j].status ===
        //     constants.PROGRESS_STATUS.UNLOCKED ||
        //   lpData.modules[i].data[j].status ===
        //     constants.PROGRESS_STATUS.REATTEMPT ||
        //   lpData.modules[i].data[j].status ===
        //     constants.PROGRESS_STATUS.QN_CONTINUE ||
        //   lpData.modules[i].data[j].status ===
        //     constants.PROGRESS_STATUS.IN_PROGRESS)
        // ) {
        //   return lpData.modules[i].data[j];
        // } else {
          return lpData.modules[i].data[j];
        // }
      }
    }

    Alert.setModuleActive(true);
    Alert.setModule({
      id: lpData.modules[0].modid,
      name: lpData.modules[0].modname,
    });

    return lpData.modules[0].data[0];
  };

  const handleGetDataForHome = () => {
    if (
      Alert.testData.parentModId ||
      (sessionStorage.getItem("modId") != null &&
        sessionStorage.getItem("modId") !== "undefined" &&
        sessionStorage.getItem("modId") !== undefined) || isPreview
    ) {
      let modid = isPreview ? mid :sessionStorage.getItem("modId") || Alert.testData.parentModId
      Alert.setLpId(parseInt(sessionStorage.getItem("lpId")));
      Alert.setUpdateLeftNav(false);
      Alert.setIsLoaded(true);
      axios
        .post(
          // "node/learner/course/get",
          "node/learner/course/module",
          JSON.stringify({
            setdd: Alert.testData.setdd || false,
            lpid: isPreview ? lpid : sessionStorage.getItem("lpId"),
            learnerid: getDataFromStorage("learnerid"),
            moduleid: modid,
            isPreview: isPreview ? true : false,
            // mocklp: localStorage.getItem("mockLp"),
            // lmpid: sessionStorage.getItem("lmpid"),
            // mockstart: sessionStorage.getItem("mockStart"),
          }),
          getHeaderDetailsForAxios()
        )
        .then((res) => {
          Alert.setIsLoaded(false);
          Alert.setIsJoinZoom(res.data.data?.join_zoom);
          localStorage.setItem("date", res.headers.date);

          if (res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR) {
            Alert.setShowNotify({
              show: true,
              title: "Info",
              msg: res.data.msg,
            });
          } else {
            if (res.data.resultCode === constants.RESULT_STATUS.NO_DATA) {
              Alert.setShowNotify({
                show: true,
                title: "Info",
                msg: "Learningpath is not published",
              });
            } else {
              Alert.setRegistered(res.data.data.registered);
              if (res.data.data.registered === 0) {
                Alert.setShowNotify({
                  show: true,
                  buttonStyle: "fill",
                  primaryButton: "Proceed",
                  secondaryButton: "Skip for now",
                  primaryButtonFunction: handleRegistration,
                  title: "Welcome to the Gradious LEAP Platform!",
                  msg: (
                    <>
                      To enable proctoring, we'll capture your photo for face
                      verification. <br />
                      If you don't have a webcam, you can skip this step for
                      now.
                    </>
                  ),
                });
              }
              localStorage.setItem("batchid",res.data.data.batchid);
              localStorage.setItem("batchname",res.data.data.batchname);
              sessionStorage.removeItem("mockStart");
              Alert.setLpId(res.data.data.courses[0].lpid);
              Alert.setShowBlink(res.data.data.markAttendance);
              res.data.data.courses[0].mode = res.data.data.mode;

              res.data.data.courses[0]?.modules?.sort(
                (module1, module2) =>
                  module1.moduleorderno - module2.moduleorderno
              );

              res.data.data.courses[0].modules.forEach((module) => {
                module?.data?.sort(
                  (item1, item2) => item1.orderno - item2.orderno
                );
              });

              if (
                !isPreview && res.data.data.courses[0].useorder !== 0 &&
                parseInt(localStorage.getItem("batchType")) !==
                  constants.BATCH_TYPE.SELF
              ) {
                getTestForOrderMandate(res.data.data.courses[0].modules);
              } else {
                if (Alert.testData && Alert.testData.pathName === "dashBoard") {
                  res.data.data.courses[0].modules.map((moduleData) =>
                    moduleData.data.filter(
                      (test) =>
                        (test.testid === Alert.testData.testId ||
                          test.libid === Alert.testData.testId) &&
                        moduleData.modid === Alert.testData.moduleId &&
                        test?.status !== constants.PROGRESS_STATUS.LOCKED &&
                        (Alert.setModuleActive(true),
                        Alert.setModule({
                          id: moduleData.modid,
                          name: moduleData.modname,
                          totalhrs: moduleData.totalhrs,
                        }),
                        openTest(test))
                    )
                  );
                } else {
                  openTest(getTest(res.data.data.courses[0]));
                }
              }

              res.data.data.courses[0].batchType = parseInt(
                localStorage.getItem("batchType")
              );

              Alert.setLpData(res.data.data.courses[0]);
            }
          }
        })
        .catch((error) => {
          getCatchBlockDetails(error);
        });
    } else {
      Alert.navigate("/main/landing");
    }
  };

  return {
    openTest,
    collapsed,
    openModule,
    setCollapsed,
    activeTestRef,
    calculatePercentage,
    handleGetDataForHome,
  };
}
